import RelatedArticlesComponent from "../../../../components/help/RelatedArticlesComponent.tsx";

export default function DataConsumptionArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="paragraph">
                        <h2>Har du fibernet eller internet via telefon- eller kabel-tv-stikket?</h2>
                        <p>
                            Vi måler ikke dit dataforbrug, da der ikke er data-begrænsning på dit produkt.
                            Du betaler nemlig for et abonnement med en hastighed, og ikke en mængde data.
                        </p>
                        <p>
                            Du kan bruge al den data du vil uden at tænke over, om du modtager en ekstra regning.
                        </p>
                        <h2>Har du 5G-internet?</h2>
                        <p>
                            Du kan ikke se, hvor meget data du bruger. Heldigvis har du ubegrænset data på dit abonnement, så du behøver slet ikke bekymre dig om dit dataforbrug.
                        </p>
                    </div>
                </div>
            </article>

            <RelatedArticlesComponent
                articles={[
                    {
                        "category": "bestilling",
                        "article": "kan-jeg-faa-1000-mbit",
                        "name": "Kan jeg få 1000 Mbit?"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "forventninger-til-wifi",
                        "name": "Hvad kan jeg forvente af mit wifi?"
                    },
                    {
                        "category": "internet-og-wifi",
                        "article": "placering-af-router",
                        "name": "Hvor er det bedst at placere sin router?"
                    },
                    {
                        "category": "mit-abonnement",
                        "article": "mit-hiper",
                        "name": "Mit Hiper"
                    }
                ]}
            />
        </>
    )
}